import type { OrbState } from "../orb";

// Welcher Monitoring-Bereich tritt hervor, wenn SIMO gerade arbeitet/wartet.
export type FocusArea = "agent" | "approvals" | "speak" | "error" | null;

/** CSS-Utility-Klasse, die `--simo-accent` je Orb-Zustand setzt (styles.css). */
export function accentClass(orb: OrbState): string {
  return `simo-accent-${orb}`;
}

/**
 * Leitet den hervorzuhebenden Panel-Bereich aus dem Live-Zustand ab:
 * - error → Fehlerfläche
 * - blocked / offene Approvals → Approval-Panel
 * - thinking / acting → AgentGraph-/Tool-Aktivität
 * - speaking → Output/Transcript
 */
export function orbFocus(orb: OrbState, hasPendingApprovals: boolean): FocusArea {
  if (orb === "error") return "error";
  if (orb === "blocked" || hasPendingApprovals) return "approvals";
  if (orb === "thinking" || orb === "acting") return "agent";
  if (orb === "speaking") return "speak";
  return null;
}
